import * as React from 'react';
import { Label } from 'semantic-ui-react';
import { DashboardRoute } from '~/Application/routes';
export var TagFilter = function (_a) {
    var children = _a.children, filter = _a.filter, condition = _a.condition, disabled = _a.disabled;
    var _b = React.useMemo(function () {
        var isActive = filter.has(condition);
        return [isActive, isActive ? filter.removed(condition) : filter.added(condition)];
    }, [filter, condition]), isActive = _b[0], newFilter = _b[1];
    var render = React.useCallback(function (props) { return (<DashboardRoute.Link filter={newFilter}>
				<a {...props}/>
			</DashboardRoute.Link>); }, [DashboardRoute.Link, newFilter]);
    return (<Label as={disabled !== true ? render : null} className={disabled === true ? 'disabled-label' : undefined} color={isActive ? 'blue' : undefined} size='small'>
			{children}
		</Label>);
};
TagFilter.displayName = 'Application.TagFilter';
